export enum QueryOperator {
  top = "top",
  count = "count",
  eq = "eq",
  ne = "ne",
  gt = "gt",
  ge = "ge",
  lt = "lt",
  le = "le",
  and = "and",
  or = "or",
  not = "not",
  contains = "contains",
  startsWith = "startswith",
}
